import $ from 'jquery';
import get from 'lodash/get';

export default function() {
    const favBrand = get(window, 'rcProps.trigger.plp.favBrand', '');
    if (favBrand === true || favBrand === 'true') {
        const addDesignerButton = $('#js-btt-fixed-target > span');
        addDesignerButton.click();
    }
}


// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/amp-favorite-brand.js